module.exports = __webpack_public_path__ + "img/A1903.8952f877.png";